import React, { ComponentProps, FC } from 'react';

import cn from 'classnames';

import './Button.scss';

type ButtonProps = ComponentProps<'button'> & {
  primary?: boolean;
  outline?: boolean;
};

const Button: FC<ButtonProps> = ({
  children,
  disabled,
  className,
  type,
  primary,
  outline,
  ref,
  ...otherProps
}) => (
  <button
    {...otherProps}
    ref={ref}
    type={type || 'button'}
    disabled={disabled}
    className={cn('button', className, primary && 'primary', outline && 'outline', {
      disabled,
    })}
  >
    {children}
  </button>
);

export default Button;
